import { render } from "./Workshop.vue?vue&type=template&id=0d7829a0&scoped=true"
import script from "./Workshop.vue?vue&type=script&lang=js"
export * from "./Workshop.vue?vue&type=script&lang=js"

import "./Workshop.vue?vue&type=style&index=0&id=0d7829a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7829a0"]])

export default __exports__